import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, tap } from 'rxjs'; 
import { LoginService } from '../services/login.service';
import * as utils from '../../shared/helpers/utils';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '../services/loading.service';
import { LicenseService } from '../services/license.service';
import { ConfigService } from '../services/config.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(
    private loginService: LoginService,
    private loadingService: LoadingService,
    private router: Router,
    private licenseService: LicenseService,
    private configSvc: ConfigService
  ) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    const auth = utils?.localStorageGetItem('auth');

    let requestPersistance: any = request;

    return next.handle(request).pipe(tap({
      error: e => {
        switch (e.status) {
          case 0:
            if (requestPersistance.url.includes('/bulk/')) {
              return; // let the component handle network/auth errors for bulk operations
            }
            this.loadingService.startLoading();
            if (requestPersistance.url.includes('/users/entities') || requestPersistance.url.includes('/settings')) {
              this.loginService.refresh(auth.refreshToken).subscribe(res => {
                this.configSvc.setConfigParamsValue('refreshingToken', false);
                utils.localStorageSetItem('auth', { 'accessToken': res.access_token, 'refreshToken': res.refresh_token });
                if (res.access_token) { location.reload(); } else { this.loginService.logOut(); }
              }, error => {
                this.configSvc.setConfigParamsValue('refreshingToken', false);
                this.loginService.logOut();
              })
            } else if (window.location.pathname === '/gaze-maps') {
              console.log('504 Gateway Timeout on gaze-maps - handled in interceptor');
            } else if (window.location.pathname !== '/licenses/packages/create') {
              this.reloadCurrentRoute();
              /*utils.toogleGenericModal('#confirmationModal-errorData', false);*/
            } else {
              if (!this.configSvc.currentConfigValue.refreshingToken) {
                /*alert('here1');*/
                return this.request(requestPersistance, next);
                /*utils.toogleGenericModal('#confirmationModal-expiredToken', false);*/
              }
            }
            break;
          case 401:
          case 403: {
            if (requestPersistance.url.includes('/bulk/')) {
              return; // error propagates naturally through tap — no page reload for bulk
            }
            this.loadingService.startLoading();
            if (window.location.pathname !== '/login') {
              if (!requestPersistance.body?.upgrade! && !requestPersistance.url.includes('/users/entities')) {
                /*alert('here2');*/
                return this.request(requestPersistance, next);
                /*utils.toogleGenericModal('#confirmationModal-expiredToken', false);*/
              } else {
                this.loginService.refresh(auth.refreshToken).subscribe(res => {
                  utils.localStorageSetItem('auth', { 'accessToken': res.access_token, 'refreshToken': res.refresh_token });
                  if (res.access_token) {
                    request = requestPersistance.clone({
                      setHeaders: {
                        authorization: res.access_token
                      }
                    });
                    //---------retry error request----------------
                    if (requestPersistance.body?.upgrade!) {
                      this.licenseService.updatePackage(requestPersistance.body).subscribe(res => {
                        this.router.navigate(['/licenses/packages/edit/' + requestPersistance.body?.upgrade!]);
                      });
                    } else {
                      if (requestPersistance.url.includes('/users/entities')) {
                        this.reloadCurrentRoute(true);
                      } else {
                        this.reloadCurrentRoute();
                      }
                    }
                  } else {
                    this.loginService.logOut();
                    return
                  }
                }, error => {
                  this.loginService.logOut();
                })
              }

            }
          }
            break;
        }
      }
    }));
  }

  reloadCurrentRoute(_full?: boolean) {
    if (_full) {
      window.location.reload();//needed to reload full browser, reloading only route doesn´t trigger requests needed
    } else {
      const currentUrl = this.router.url;
      this.router.navigateByUrl('/', { skipLocationChange: false }).then(() => {
        this.router.navigate([currentUrl]);
      });
    }
  }

  request (_request: any, next: HttpHandler) {
    this.configSvc.setConfigParamsValue('refreshingToken', true);
    const auth = utils?.localStorageGetItem('auth');
        this.loginService.refresh(auth.refreshToken).subscribe(res => {
          utils.localStorageSetItem('auth', { 'accessToken': res.access_token, 'refreshToken': res.refresh_token });
          if (res.access_token) {  this.reloadCurrentRoute(); } else { this.loginService.logOut(); }
        }, error => {
          this.loginService.logOut();
        })
  }
  
}